// GET SURVEY BY EVENT
export const GET_SURVEY_EVENT = 'app/store/survey/GET_SURVEY_EVENT';
export const GET_SURVEY_EVENT_SUCCESS = 'app/store/survey/GET_SURVEY_EVENT_SUCCESS';
export const GET_SURVEY_EVENT_ERROR = 'app/store/survey/GET_SURVEY_EVENT_ERROR';

// SET current survey
export const SET_CURRENT_SURVEY = 'app/store/survey/SET_CURRENT_SURVEY';
